module.exports = __webpack_public_path__ + "img/luxtrust.f077a7dd.svg";